/* sp-global.js — klon bölümlerinin ortak yardımcıları (metin yok; tüm metinler Liquid/locales'ten gelir) */
(function () {
  const cfg = window.spConfig || {};
  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
  function fmtAmount(cents) {
    const neg = cents < 0; cents = Math.round(Math.abs(cents));
    const whole = Math.floor(cents / 100), frac = cents % 100;
    const wholeS = whole.toLocaleString('en-US');
    return (neg ? '-' : '') + wholeS + '.' + pad(frac, 2);
  }
  function money(cents) {
    if (cfg.moneyOverride) return (cfg.spMoneyFormat || '$[amount]').replace('[amount]', fmtAmount(Math.abs(cents))).replace(/^/, cents < 0 ? '-' : '');
    // Shopify money_format: {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}} ...
    const f = cfg.moneyFormat || '${{amount}}';
    const a = Math.abs(cents) / 100;
    let s = f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(a).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, a.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    s = s.replace(/<[^>]+>/g, '');
    return (cents < 0 ? '-' : '') + s;
  }
  window.sp = Object.assign(window.sp || {}, { money, fmtAmount, pad });
  // Sepet olayları: bölümler cart:updated'a abone olur
  window.sp.emit = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail })); };

  // Esc çekmeceyi her durumda kapatsın: Dawn yalnız çekmecenin kendi keyup'ını dinliyor, çekmece
  // başlıktaki sepet ikonuyla açıldığında odak dışarıda kalabildiği için olay ona hiç ulaşmıyordu.
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    const d = document.querySelector('cart-drawer.active');
    if (d && typeof d.close === 'function') d.close();
  });
})();
